import React, { useEffect, useState } from 'react';
import baseURL from '../url';

export default function Flyer(){
  const api = baseURL;
  const [item, setItem] = useState(null);
  const [open, setOpen] = useState(false);
  const [anim, setAnim] = useState('in');
  useEffect(()=>{
    if (window.__flyerShownSession) { setItem(null); setOpen(false); return; }
    fetch(`${api}/flyersGet.php?activos=1`).then(r=>r.text()).then(t=>{
      try{
        const j=JSON.parse(t);
        const arr = j.items||[];
        if (arr.length>0){
          let idx = parseInt(localStorage.getItem('flyerIndex') || '0', 10);
          if (isNaN(idx) || idx < 0) idx = 0;
          if (idx >= arr.length) idx = 0;
          setItem(arr[idx]);
          setOpen(true);
          setAnim('pre');
          setTimeout(()=>{ setAnim('in'); }, 30);
          window.__flyerShownSession = true;
          const nextIdx = (idx + 1) % arr.length;
          localStorage.setItem('flyerIndex', String(nextIdx));
        } else {
          setItem(null);
          setOpen(false);
        }
      } catch(_){
        setItem(null);
        setOpen(false);
      }
    });
  },[]);
  const close = () => { setAnim('out'); setTimeout(()=>{ setOpen(false); window.__flyerShownSession = true; }, 300); };
  if (!open || !item) return null;
  const imgStyle = { maxWidth:'90vw', maxHeight:'80vh', width:'auto', height:'auto', objectFit:'contain', borderRadius:8, boxShadow:'0 6px 20px rgba(0,0,0,0.25)', transform: anim==='in' ? 'scale(1) rotate(1440deg)' : 'scale(0.05) rotate(0deg)', transition:'transform .9s ease-out', willChange:'transform' };
  const btnStyle = { marginTop:12, background:'#e02424', color:'#fff', border:'none', borderRadius:20, padding:'10px 16px', cursor:'pointer' };
  const onOverlayClick = (e) => {
    if (e.target === e.currentTarget) { close(); }
  };
  return (
    <div onClick={onOverlayClick} style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.6)', zIndex:10000, opacity: (anim==='in'||anim==='pre') ? 1 : 0, transition:'opacity .3s ease', display:'flex', alignItems:'center', justifyContent:'center', flexDirection:'column' }}>
      {item.imagen && (
        (item.url ? (
          <a href={/^https?:|^mailto:|^tel:/i.test(item.url) ? item.url : `http://${item.url}`} target='_blank' rel='noreferrer'>
            <img loading="lazy" decoding="async" width="1200" height="800" src={/^https?:/i.test(item.imagen) ? item.imagen : `${api}/${String(item.imagen).replace(/^\//,'')}`} alt='flyer' style={imgStyle} />
          </a>
        ) : (
          <img loading="lazy" decoding="async" width="1200" height="800" src={/^https?:/i.test(item.imagen) ? item.imagen : `${api}/${String(item.imagen).replace(/^\//,'')}`} alt='flyer' style={imgStyle} />
        ))
      )}
      <button style={btnStyle} onClick={close}>Cerrar</button>
    </div>
  );
}
